const contact = {
    title: 'Contattaci',
    subtitle: 'Siamo qui per aiutarti a pianificare la tua esperienza perfetta in Abruzzo',
    companyInformation: 'Informazioni Aziendali',
    authenticExperiences: 'Esperienze autentiche in Abruzzo',
    address: 'Indirizzo',
    phone: 'Telefono',
    email: 'Email',
    vatNumber: 'P.IVA',
    openingHours: 'Orari di Apertura',
    mondayFriday: 'Lunedì - Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica',
    closed: 'Chiuso',
    sendRequest: 'Invia una Richiesta',
    nameLabel: 'Nome *',
    subjectLabel: 'Oggetto *',
    emailLabel: 'Email *',
    phoneLabel: 'Telefono (opzionale)',
    phoneOptional: 'Telefono (opzionale)',
    messageLabel: 'Descrizione della Richiesta *',
    messagePlaceholder: 'Descrivi la tua richiesta, domande o richieste speciali...',
    namePlaceholder: 'Il tuo nome',
    emailPlaceholder: 'la-tua-email@esempio.com',
    subjectPlaceholder: 'Oggetto del messaggio',
    submitButton: 'Invia Richiesta',
    submitting: 'Invio in corso...',
    successMessage: 'Grazie! La tua richiesta è stata inviata con successo. Ti risponderemo presto.',
    errorMessage: 'Si è verificato un errore. Riprova più tardi.',
    charactersRemaining: 'caratteri rimanenti',
    charactersLeft: 'caratteri rimasti',
    nameInvalidChars: 'Il nome può contenere solo lettere, spazi, trattini e apostrofi',
    subjectInvalidChars: 'L\'oggetto può contenere solo lettere, numeri, spazi e punteggiatura di base',
};

export default contact;
